import { render, staticRenderFns } from "./ItemHorarioRow.vue?vue&type=template&id=29c48c9e&"
import script from "./ItemHorarioRow.vue?vue&type=script&lang=js&"
export * from "./ItemHorarioRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports